import { notifyError } from "common/utils/app-monitoring/notify";

export type NamedInit = [string, () => void];

// Runs each init in order, isolating failures so one throwing init cannot
// silently prevent the inits after it from running (MN-10445: an earlier
// throw in the "app" registry chain was killing initProductsFilter() with
// no visible error).
export function runInits(inits: NamedInit[]): void {
  inits.forEach(([name, fn]) => {
    try {
      fn();
    } catch (e) {
      const error = e instanceof Error ? e : new Error(String(e));
      notifyError(error, { context: { initName: name } });
    }
  });
}
